import { Checkbox } from '@arcadiapower/shrike';
import { useState } from 'react';
import { Button } from '~/components/button';
import { Form } from '~/components/form';
import { Text } from '~/components/typography';
import { useCopy } from '~/hooks';
import { fetchFunnelPacket } from '~/services/fetch-funnel-packet';
import { AsyncReturnType } from '~/typings/utils';
import { CEP_MEET_LINK } from '~/utils/constants';
import { OneItemGrid, AcuityColumn } from './acuity.styles';

export const Acuity = ({ context, next, overrideCopy }: AcuityProps) => {
  const copy = useCopy(context, defaultCopy, overrideCopy);
  const [scheduledCall, setScheduledCall] = useState(false);
  return (
    <AcuityColumn testId="screen-Acuity">
      <OneItemGrid>
        <iframe
          src={CEP_MEET_LINK}
          title="Schedule Appointment"
          width="100%"
          height="800px"
          style={{ border: 0, padding: 0, overflow: 'hidden' }}
        />
        <Form onSubmit={next}>
          <Checkbox
            margin="16px 0 16px 0"
            checked={scheduledCall}
            onChange={e => setScheduledCall(e.target.checked)}
          >
            <Text textStyle="paragraph400" color="secondary">
              I have scheduled a call with Community Energy Project (CEP) to confirm my eligibility.
            </Text>
          </Checkbox>

          <Button
            mode="primary"
            disabled={!scheduledCall}
            loading={false}
            testId="submit-calendy-schedule"
            type="submit"
          >
            {copy.next}
          </Button>
        </Form>
      </OneItemGrid>
    </AcuityColumn>
  );
};

export const defaultCopy = () => {
  return {
    next: 'Continue',
  };
};

export type AcuityCopy = ReturnType<typeof defaultCopy>;

export interface AcuityProps {
  context: AcuityContext;
  next: () => void;
  overrideCopy?: (context: AcuityContext) => Partial<AcuityCopy>;
}

export interface AcuityContext {
  funnelPacket: AsyncReturnType<typeof fetchFunnelPacket>;
}
